export default __webpack_public_path__ + "static/media/unnamed-4.15e0fd53.png";